<template>
  <div class="collections__all">
    <div class="collections__all__header">
      <h2>Collections Table</h2>
    </div>
    <div class="collections__all__container pb-16">
      <Table :columns="columns" :data="collections" @change="handleTable">
        <template v-slot:order="scope">
          <a-input
            placeholder="Eg. 0, 10, 20, 30"
            v-model:value="scope.item.order"
          />
        </template>
        <template v-slot:title="scope">
          <a-input
            placeholder="Eg. December, Christmas"
            v-model:value="scope.item.title"
          />
        </template>
        <template v-slot:tags="scope">
          <div class="advertisement__tags">
            <a-tag color="green" v-for="tag in scope.item.tags" :key="tag">
              {{ tag }}
            </a-tag>
          </div>
        </template>
        <template v-slot:is_new="scope">
          <Switch
            v-model="scope.item.is_new"
            @change="changeNewStatus(scope.item)"
          />
        </template>
        <template v-slot:public="scope">
          <span
            class="cursor-pointer flex items-center rounded-md bg-green-600 py-1 px-2 ml-2"
            v-if="Boolean(scope.item.public)"
            @click="scope.item.public = false"
          >
            <Icon
              name="ClipboardCheck"
              class="w-4 h-4 mr-1"
              style="stroke: white;"
            />
            <p class="text-sm font-medium text-white">Public</p>
          </span>
          <span
            class="cursor-pointer flex items-center rounded-md bg-yellow-600 py-1 px-2 ml-2"
            v-else
            @click="scope.item.public = true"
          >
            <Icon name="Clock" class="w-4 h-4 mr-1" style="stroke: white;" />
            <p class="text-sm font-medium text-white">Pending</p>
          </span>
        </template>
        <template v-slot:advertisements="scope">
          <p>{{ scope.item.advertisements.length }} ads</p>
        </template>
        <template v-slot:collection_date="scope">
          <a-month-picker
            placeholder="Select month"
            v-model:value="scope.item.collection_date"
            picker="month"
            format="YYYY-MM"
          />
        </template>
        <template v-slot:actions="scope">
          <a-button @click="saveCollection(scope.item)">Save</a-button>
          <a-button class="ml-2" @click="beforeDeleteCollection(scope.item)">
            Delete
          </a-button>
          <a-button
            v-if="!scope.item.bulked"
            class="ml-2"
            type="primary"
            @click="bulkInsertCollections(scope.item)"
          >
            Bulk Insert
          </a-button>
          <a-button v-else class="ml-2" disabled>
            Done!
          </a-button>
          <DeleteCollectionModal
            v-model:isVisible="scope.item.activeDeleteModal"
            @done="deleteCollection(scope.item.id)"
          />
        </template>
      </Table>
    </div>
    <div
      class="w-full bg-white h-16 absolute left-0 bottom-0 border-t flex items-center justify-end px-12"
    >
      <button @click="newRow" class="bg-blue-600 text-white px-4 py-2">
        New Row
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import Table from "@/components/Table/index";
import Icon from "@/components/UI/Icon";
import Switch from "@/components/UI/Switch";
import DeleteCollectionModal from "@/components/Modals/DeleteCollection";
export default {
  components: { Table, Icon, Switch, DeleteCollectionModal },
  data() {
    return {
      columns: [
        {
          title: "Order",
          dataIndex: "order",
          key: "id",
          slot: true,
        },
        {
          title: "Title",
          dataIndex: "title",
          key: "id",
          slot: true,
          style: {
            width: "200px",
          }
        },
        {
          title: "New",
          dataIndex: "is_new",
          key: "id",
          slot: true,
        },
        {
          title: "Public",
          dataIndex: "public",
          key: "id",
          slot: true,
        },
        {
          title: "Advertisements (COUNT)",
          dataIndex: "advertisements",
          key: "id",
          slot: true,
        },
        {
          title: "Collection Month",
          dataIndex: "collection_date",
          key: "id",
          slot: true,
        },
        {
          title: "Actions",
          dataIndex: "actions",
          key: "actions",
          slot: true,
          style: {
            width: "300px",
          },
        },
      ],
    };
  },
  setup() {
    const store = useStore();

    onMounted(async () => {
      await store.dispatch("GET_ROLES");
      await store.dispatch("GET_COLLECTIONS");
    });

    const roles = computed(() => store.state.roles);
    const collections = computed(() => store.state.collections);

    const saveCollection = (item) => {
      store.dispatch("UPDATE_COLLECTION", JSON.parse(JSON.stringify(item)));
    };

    const changeNewStatus = (item) => {
      store.dispatch(
        "UPDATE_COLLECTION_ADVERTISEMENT",
        JSON.parse(JSON.stringify(item))
      );
    };

    const newRow = () => {
      store.dispatch("CREATE_COLLECTION");
    };

    const beforeDeleteCollection = (item) => {
      let collection = JSON.parse(JSON.stringify(item));
      collection.activeDeleteModal = true;
      store.commit("SET_COLLECTION_BY_ID", collection);
    };

    const deleteCollection = (id) => {
      store.dispatch("DELETE_COLLECTION", id);
    };

    const bulkInsertCollections = (item) => {
      store.dispatch("BULK_INSERT_COLLECTIONS", item);
    };

    const handleTable = (value) => {
      store.commit("SET_COLLECTION_BY_ID", value);
    }

    return {
      roles,
      collections,
      saveCollection,
      newRow,
      beforeDeleteCollection,
      deleteCollection,
      bulkInsertCollections,
      handleTable,
      changeNewStatus,
    };
  },
};
</script>

<style scoped>
.collections__all {
  max-width: calc(100vw - 200px);
  margin: 0 auto;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
}
.collections__all__header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.collections__all__container {
  align-self: start;
  max-width: calc(100vw - 200px);
  height: calc(100vh - 80px);
}
</style>
